
import { supabase } from '@/integrations/supabase/client';

export interface CriteriaOption {
  category: string;
  value: string;
}

/**
 * Reads job criteria options from the database
 * @returns Array of CriteriaOption objects
 */
export const readJobCriteriaFromDatabase = async (): Promise<CriteriaOption[]> => {
  try {
    console.log('Loading job criteria from database...');
    
    const { data, error } = await supabase
      .from('job_criteria')
      .select('*')
      .limit(1)
      .single();
    
    if (error) {
      console.error('Error fetching job criteria from database:', error);
      throw error;
    }
    
    if (!data) {
      console.warn('No job criteria data found in database');
      return [];
    }
    
    console.log('Successfully loaded job criteria from database');
    
    // Transform database data to CriteriaOption format
    const options: CriteriaOption[] = [];
    
    const categories = [
      'country',
      'experience', 
      'site',
      'profession',
      'discipline',
      'role_type',
      'employment_type'
    ];
    
    for (const category of categories) {
      const values = data[category] || [];
      if (Array.isArray(values)) {
        values.forEach(value => {
          if (typeof value === 'string' && value.trim() !== '') {
            options.push({
              category,
              value: value.trim()
            });
          }
        });
      }
    }
    
    console.log(`Extracted ${options.length} options from database`);
    return options;
    
  } catch (error) {
    console.error('Error reading job criteria from database:', error);
    throw error;
  }
};
